// extracted by mini-css-extract-plugin
module.exports = {"jobListLink":"InDemandJobsList_jobListLink__x0lbR"};